export default "__VITE_ASSET__CaQ_$wQ3__"